import { Order } from "../types/order";

// Mock data for orders
export const orderData: Order[] = [
    {
        id: "12354739",
        name: "Brake Pad",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Delivered",
        image: "/order1.png"
    },
    {
        id: "12354740",
        name: "Fuel Pump",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Processing",
        image: "/order2.png"
    },
    {
        id: "12354741",
        name: "Fuel Filter",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Shipped",
        image: "/order3.png"
    },
    {
        id: "12354742",
        name: "Steering Rack",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Delivered",
        image: "/order4.png"
    },
    {
        id: "12354743",
        name: "Radiator",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Returned",
        image: "/order5.png"
    },
    {
        id: "12354744",
        name: "Carburettor",
        price: "₦20,000.00",
        date: "20-10-2024",
        status: "Delivered",
        image: "/order6.png"
    }
];